import Vue from 'vue';
import util from '@/utils/generalUtil';
import { encodePathSegment } from '@/utils/url';

export default (product) => {
  if (product.brand === '') {
    product = util.omit(product, 'brand');
    product = util.omit(product, 'type');
  }

  return Vue.$http.patch(`Products/${encodePathSegment(product.id)}`, product);
};



// WEBPACK FOOTER //
// ./src/services/product/edit.js